import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SenhaService } from 'src/app/services';

@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss']
})
export class RedefinirSenhaComponent implements OnInit, OnDestroy {
  subscription$ = new Subscription();
  redefinirSenhaForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private senhaService: SenhaService,
    private router: Router
  ) {}

  redefinirSenha() {
    this.subscription$.add(
      this.senhaService.postSenha(this.redefinirSenhaForm.value).subscribe({
        next: () => {
          this.router.navigate(['/login']);
        }
      })
    );
  }

  ngOnInit(): void {
    this.redefinirSenhaForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
